import React from "react";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { userId } from "../../Utils/LocalStorage";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import "../Dashboard/Dashboard.css";
import { TableData } from "./DummyTableData";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import VouchurePic from "../../assets/vouchure.svg";
import CoupenPic from "../../assets/coupens.svg";
import Savings from "../../assets/savings.svg";
import RecentActivities from "../../Components/RecentActivities/RecentActivities";
import { useState } from "react";
import { dashboardApi } from "../../Utils/Api/Dashboard";
import { useEffect } from "react";
import Loader from "../../Components/Loader/Loader";
import Dash2 from "../../assets/YTD.svg";
import Dash3 from "../../assets/ThisMonth.svg";
import Dash4 from "../../assets/TotalCouponsDownloaded.svg";
import Dash5 from "../../assets/EmailSent.svg";
import { toast } from "react-toastify";

const Dashboard = () => {
  const [topSectiondata1, setTopSectionData1] = useState([]);
  const [topSectiondata2, setTopSectionData2] = useState([]);
  const [headersData, setHeadersData] = useState([]);
  const [recentActivityData, setRecentActivityData] = useState([]);
  const [loading, setLoading] = useState(false);

  const buId = userId();

  const navigate = useNavigate();

  const DashboardApiHandler = async () => {
    const data = {
      user_id: buId,
    };
    setLoading(true);
    const dashboardData = await dashboardApi(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (dashboardData.status == 429) {
      setLoading(true);
      toast.error(dashboardData.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }

    setTopSectionData1(dashboardData["top_section1"]);
    setTopSectionData2(dashboardData["top_section2"]);
    setHeadersData(dashboardData["headers"]);
    setRecentActivityData(dashboardData["voucher_details"]);
  };

  // console.log(recentActivityData);

  useEffect(() => {
    DashboardApiHandler();
  }, []);
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          {/* <p className="page-text dashboard">
            <Link>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p> */}

          <p className="page-maintitle">Dashboard</p>
          <Row className="dashboard-card mt-4 ">
            {topSectiondata1?.length > 0 ? (
              <>
                <Col md="4">
                  <div className="card green-card">
                    <div className="dash-img-main">
                      <div className="dash-img">
                        <Image
                          loading="lazy"
                          src={Savings}
                          height="18px"
                        ></Image>
                      </div>
                    </div>
                    <div className="dash-content">
                      <p className="dash-text1 pt-4">
                        {topSectiondata1[0].title}
                      </p>
                      <p className="dash-text2">
                        $
                        {topSectiondata1[0].amount == ""
                          ? 0
                          : topSectiondata1[0].amount}
                      </p>
                      <p className="text-right pb-4"></p>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card green-card">
                    <div className="dash-img-main">
                      <div className="dash-img">
                        <Image loading="lazy" src={Dash2} height="25px"></Image>
                      </div>
                    </div>
                    <div className="dash-content">
                      <p className="dash-text1 pt-4">
                        {topSectiondata1[1].title}
                      </p>
                      <p className="dash-text2">
                        $
                        {topSectiondata1[1].amount == ""
                          ? 0
                          : topSectiondata1[1].amount}
                      </p>
                      <p className="text-right pb-4"></p>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card green-card">
                    <div className="dash-img-main">
                      <div className="dash-img">
                        <Image loading="lazy" src={Dash3} height="18px"></Image>
                      </div>
                    </div>
                    <div className="dash-content">
                      <p className="dash-text1 pt-4">
                        {topSectiondata1[2].title}
                      </p>
                      <p className="dash-text2">
                        $
                        {topSectiondata1[2].amount == ""
                          ? 0
                          : topSectiondata1[2].amount}
                      </p>
                      <p className="text-right pb-4"></p>
                    </div>
                  </div>
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
          <Row className="dashboard-card mt-4 ">
            {topSectiondata2?.length > 0 ? (
              <>
                <Col md="4">
                  <div className="card">
                    <div className="dash-img-main">
                      <div className="dash-img">
                        <Image
                          loading="lazy"
                          src={VouchurePic}
                          height="15px"
                        ></Image>
                      </div>
                    </div>
                    <div className="dash-content">
                      <p className="dash-text1 pt-4">
                        {topSectiondata2[0].title}
                      </p>
                      <p className="dash-text2">
                        {topSectiondata2[0].quantity}
                      </p>
                      <p className="text-right pb-4"></p>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card">
                    <div className="dash-img-main">
                      <div className="dash-img">
                        <Image loading="lazy" src={Dash4} height="25px"></Image>
                      </div>
                    </div>
                    <div className="dash-content">
                      <p className="dash-text1 pt-4">
                        {topSectiondata2[1].title}
                      </p>
                      <p className="dash-text2">
                        {topSectiondata2[1].quantity}
                      </p>
                      <p className="text-right pb-4"></p>
                    </div>
                  </div>
                </Col>
                {/* <Col md="4">
                  <div className="card">
                    <div className="dash-img-main">
                      <div className="dash-img">
                        <Image loading="lazy" src={Dash5} height="20px"></Image>
                      </div>
                    </div>
                    <div className="dash-content">
                      <p className="dash-text1 pt-4">
                        {topSectiondata2[2].title}
                      </p>
                      <p className="dash-text2">
                        {topSectiondata2[2].quantity}
                      </p>
                      <p className="text-right pb-4"></p>
                    </div>
                  </div>
                </Col> */}
              </>
            ) : (
              <></>
            )}
          </Row>
          <div className="mt-5">
            <RecentActivities
              headers={headersData}
              recentActivity={recentActivityData}
            />
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Dashboard;
